'use client';

import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ArrowRight, BookOpen } from 'lucide-react';

export const SmartToast = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show toast after 25 seconds of being on the page
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 25000);

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 50, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 20, scale: 0.95 }}
        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
        className="fixed bottom-6 right-6 z-50 w-full max-w-sm"
      >
        <div className="bg-white border border-[#8C6D37]/30 shadow-2xl rounded-[2px] overflow-hidden">
          <div className="bg-[#FAF8F5] px-4 py-3 border-b border-[#EAE5DE] flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="relative flex h-2 w-2 shrink-0">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#8C6D37] opacity-75" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#8C6D37]" />
              </span>
              <span className="font-mono text-[10px] text-[#8C6D37] uppercase tracking-wider font-bold">
                База знаний M&A
              </span>
            </div>
            <button 
              onClick={() => setIsVisible(false)}
              className="text-[#64748B] hover:text-[#141416] transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          <div className="p-5 flex flex-col gap-4">
            <h4 className="font-serif font-semibold text-[#141416] text-[15px] leading-snug">
              Хотите узнать, как оценить вашу клинику до 7.5x EBITDA?
            </h4>
            <p className="text-[#64748B] text-[13px] leading-relaxed">
              Ознакомьтесь с нашей базой из 30+ разобранных M&A кейсов: от продажи стоматологий на 3 кресла до федеральных многопрофильных центров.
            </p>
            <button 
              onClick={() => {
                setIsVisible(false);
                document.getElementById('vault-docs')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-center justify-between bg-[#141416] text-white px-4 py-2.5 rounded-[2px] font-mono text-[11px] font-bold tracking-widest uppercase transition-colors hover:bg-[#8C6D37]"
            >
              <span>Открыть базу кейсов</span>
              <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
            </button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};
